module.exports = __webpack_public_path__ + "img/choose-up-Up Social Mures-disabled.47ac394a.png";